module.exports = __webpack_public_path__ + "static/media/s_v8_t1_1.0abc1ba0.mp3";